<template>
  <li class="nav-item dropdown d-md-down-none">
    <a class="btn btn-sm btn-dark" target="_blank" :href="this.$constant.BROKER_MANUAL_URL">マニュアル</a>
  </li>
</template>

<script>

export default {
  name: "ManualBrowseItem",
  inject: [
    '$constant'
  ],
}
</script>
